goog.provide('el8.appchart.refpanel.printOrFax');

goog.require('el8.appchart.mgr.thirdpane');
goog.require('el8.service.urls');
goog.require('el8.uiwidget.QuickSelectDialog');
goog.require('el8.util.consts');


/**
 * A QuickSelect for the user to either print or fax (attach-to-letter)
 * the Clinical Profile (refpanel)
 */
 el8.appchart.refpanel.printOrFax = (function() {

    var that = new el8.uiwidget.QuickSelectDialog({
        title: 'Share Profile',
        callbackFn: function(index) {
            var lookup = [
                function() {
                    el8.appchart.mgr.thirdpane.attachToLetter({
                        type: el8.util.consts.CONSULTANT_LETTER,
                        attachmentId: el8.util.consts.REFPANEL_PSEUDO_CLASS
                    });
                    that.hide();
                },
                function() {
                    window.open(el8.service.urls.get('printRefPanel'));
                    that.hide();
                }
            ];
            return lookup[index] ? lookup[index]() : null;
        },
        list: [
            'Fax directly from Elation',
            'Print'
        ]
    });

    return that;

})();